export function Home() {
  return (
    <div className="min-h-screen flex flex-col">
      {/* Header */}
      <header className="w-full sticky top-0 z-10 bg-background/80 backdrop-blur supports-[backdrop-filter]:bg-background/60 border-b">
        <div className="mx-auto max-w-6xl px-4 sm:px-6 h-16 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="size-8 rounded-lg bg-primary/10 flex items-center justify-center shadow-sm overflow-hidden">
              <img
                src="https://storage.stardeck.ai/images/dcb798c7-da0a-412e-8dda-5829464125e4.svg"
                alt="Greenfield Labs logo"
                className="size-6"
              />
            </div>
            <span className="font-semibold tracking-tight">Greenfield Labs</span>
          </div>
          <nav className="hidden sm:flex items-center gap-6 text-sm">
            <a
              href="#about"
              className="text-muted-foreground hover:text-foreground transition-colors"
            >
              About
            </a>
            <a
              href="#contact"
              className="text-muted-foreground hover:text-foreground transition-colors"
            >
              Contact
            </a>
            <a
              href="mailto:hello@xgreenfield.com"
              className="inline-flex items-center justify-center rounded-md bg-primary px-4 py-2 text-primary-foreground shadow-sm hover:opacity-95 transition-colors"
            >
              Contact us
            </a>
          </nav>
        </div>
      </header>

      {/* Hero */}
      <section className="relative isolate">
        <div className="mx-auto max-w-6xl px-4 sm:px-6 py-16 sm:py-24 grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          <div className="space-y-6">
            <h1 className="text-4xl sm:text-5xl font-semibold leading-tight tracking-tight text-foreground">
              We build agentic AI products that ship.
            </h1>
            <p className="text-lg text-muted-foreground max-w-prose">
              We experiment, explore, and build products that use AI to solve problems for everyone.
            </p>
            <div className="flex items-center gap-3">
              <a
                href="mailto:hello@xgreenfield.com"
                className="inline-flex items-center justify-center rounded-lg bg-primary px-5 py-3 text-primary-foreground shadow-sm hover:opacity-95 transition-colors"
              >
                Contact us
              </a>
            </div>

            <div className="pt-6">
              <div className="inline-flex items-center gap-2 rounded-full bg-primary/5 px-3 py-1 text-sm text-muted-foreground">
                <span className="size-1.5 rounded-full bg-primary"></span>
                Trusted by innovative teams
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="rounded-2xl overflow-hidden shadow-sm ring-1 ring-border bg-card">
              <img
                src="https://images.pexels.com/photos/2078266/pexels-photo-2078266.jpeg"
                alt="Soft green abstract gradient background"
                className="w-full h-72 sm:h-96 object-cover"
                loading="eager"
              />
            </div>
          </div>
        </div>
      </section>

      {/* About / Team */}
      <section id="about" className="mx-auto max-w-6xl px-4 sm:px-6 py-12 sm:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="md:col-span-1">
            <h2 className="text-2xl font-semibold">About</h2>
          </div>
          <div className="md:col-span-2 space-y-4">
            <p className="text-muted-foreground">
              Jenn built Seer, the Agentic AI debugger for Sentry.
            </p>
            <p className="text-muted-foreground max-w-prose">
              At Greenfield Labs, we focus on practical agentic systems that deliver real outcomes.
              We prototype quickly, validate with users, and turn promising ideas into reliable
              products. Our work blends strong engineering with thoughtful design so teams can ship
              faster with confidence.
            </p>
          </div>
        </div>
      </section>

      {/* Contact / CTA */}
      <section id="contact" className="mx-auto max-w-6xl px-4 sm:px-6 pb-16 sm:pb-24">
        <div className="rounded-2xl border bg-card p-6 sm:p-8 shadow-sm">
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
            <div>
              <h3 className="text-xl font-semibold">Let’s build something great</h3>
              <p className="text-muted-foreground">Tell us about your product or team needs.</p>
            </div>
            <a
              href="mailto:hello@xgreenfield.com"
              className="inline-flex items-center justify-center rounded-lg bg-primary px-5 py-3 text-primary-foreground shadow-sm hover:opacity-95 transition-colors"
            >
              Contact us
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="mt-auto border-t">
        <div className="mx-auto max-w-6xl px-4 sm:px-6 h-16 flex items-center justify-between text-sm text-muted-foreground">
          <span>© {new Date().getFullYear()} Greenfield Labs</span>
          <a
            href="mailto:hello@xgreenfield.com"
            className="hover:text-foreground transition-colors"
          >
            hello@xgreenfield.com
          </a>
        </div>
      </footer>
    </div>
  );
}
